import LdsPage from 'gatsby-theme-husky/src/templates/LdsPage/LdsPage';

import './ldsPageOverride.scss';

export default LdsPage;
